import { createColumnHelper } from "@tanstack/react-table"
import { CountryCell, TextCell } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { COUNTRIES } from "~/utils/countries"

const columnHelper =
  createColumnHelper<LibraryResponses.SupplierProductionSiteInfo>()

export const useColumns = (prodsiteFieldKeys: string[]) => {
  const { t } = useTranslation("suppliers")

  return useMemo(
    () => [
      columnHelper.accessor("name", {
        id: "name",
        enablePinning: true,
        header: t("productionSites.columns.name"),
        cell: (info) => <TextCell value={info.getValue()} />,
      }),

      columnHelper.accessor("address", {
        id: "address",
        header: t("productionSites.columns.address"),
        cell: (info) => <TextCell value={info.getValue()} />,
      }),

      columnHelper.accessor("country", {
        id: "country",
        header: t("productionSites.columns.country"),
        cell: (info) => {
          const country = info.getValue()

          return (
            <CountryCell
              countryIso3166={country}
              w="100%"
              countriesMapper={COUNTRIES}
            />
          )
        },
      }),
      columnHelper.accessor("email", {
        id: "supplier",
        header: t("productionSites.columns.contactEmail"),
        cell: ({ row }) => {
          if (row.original.confidential) {
            return (
              <TextCell value={t("productionSites.columns.confidential")} />
            )
          }
          return <TextCell value={row.original.email} />
        },
      }),
      ...Object(
        prodsiteFieldKeys.map((prodsiteFieldKey) => {
          return columnHelper.accessor(
            (row) => {
              return row.prodSiteFields.find(
                (psf) => psf.key === prodsiteFieldKey
              )?.value
            },
            {
              id: prodsiteFieldKey + "-id",
              header: prodsiteFieldKey,
              enableSorting: false,
              cell: (info) => <TextCell value={info.getValue()} />,
            }
          )
        })
      ),
    ],
    [t, prodsiteFieldKeys]
  )
}
